"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Youtube/index.ts
var Youtube_exports = {};
__export(Youtube_exports, {
  Embed: () => Embed,
  getIdFromYoutubeUrl: () => getIdFromYoutubeUrl,
  isValidYoutubeUrl: () => isValidYoutubeUrl
});
module.exports = __toCommonJS(Youtube_exports);

// src/components/Youtube/Embed.tsx
var import_react2 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames = __toESM(require("classnames"));

// src/components/Youtube/util.ts
function getIdFromYoutubeUrl(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : null;
}
function isValidYoutubeUrl(url) {
  const regExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))/;
  const youtubeId = getIdFromYoutubeUrl(url);
  return regExp.test(url) && !!youtubeId;
}

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react = __toESM(require("react"));

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faImageSlash = {
  prefix: "fas",
  iconName: "image-slash",
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var EmbedErrorState = ({
  text,
  className = ""
}) => {
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: `
        v2-w-64 v2-h-40 v2-bg-neutral-100 v2-text-neutral-500 v2-rounded-md
        v2-border v2-border-solid v2-border-neutral-300 v2-flex v2-flex-col
        v2-justify-center v2-text-center v2-text-base v2-items-center
        ${className}`
    },
    /* @__PURE__ */ import_react.default.createElement(import_react_fontawesome.FontAwesomeIcon, { className: "v2-h-7", icon: faImageSlash }),
    /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-m-3.5" }, text)
  );
};

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/Youtube/Embed.tsx
var PlayButton = import_styled.default.img`
  transform: translate3d(-50%, -50%, 0);
  filter: grayscale(100%);

  &:hover {
    filter: none;
  }
`;
var Container = import_styled.default.div`
  &:hover img {
    filter: none;
  }
`;
var Embed = import_react2.default.forwardRef(
  ({
    containerRef: defaultContainerRef,
    youtubeUrl,
    showControls = false,
    hideErrorState = false,
    className = "",
    errorStateClassName = "",
    onLoad,
    onLoadError,
    cornerRadius = 6,
    hideShadow = false,
    showBorder = false,
    borderWidth,
    borderColor,
    style
  }, ref) => {
    const containerRef = defaultContainerRef != null ? defaultContainerRef : (0, import_react2.useRef)(null);
    const youtubeId = (0, import_react2.useMemo)(
      () => getIdFromYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    const [showIframe, setShowIframe] = (0, import_react2.useState)(false);
    const [preConnection, setPreConnection] = (0, import_react2.useState)(false);
    const isValidYoutube = (0, import_react2.useMemo)(
      () => isValidYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    (0, import_react2.useEffect)(() => {
      if (!isValidYoutube || !youtubeId) {
        onLoadError == null ? void 0 : onLoadError();
      }
    }, [isValidYoutube, youtubeUrl]);
    if ((!isValidYoutube || !youtubeId) && hideErrorState) {
      return null;
    }
    if (!isValidYoutube) {
      return /* @__PURE__ */ import_react2.default.createElement(
        EmbedErrorState,
        {
          className: errorStateClassName,
          text: "The URL you've provided is not a valid Youtube URL."
        }
      );
    }
    const posterUrl = `https://i3.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
    const youtubeEmbedUrl = `https://www.youtube.com/embed/${youtubeId}?rel=0&controls=${Number(
      showControls
    )}&autoplay=1`;
    return /* @__PURE__ */ import_react2.default.createElement(
      Container,
      {
        ref,
        className: (0, import_classnames.default)(className, "v2-w-96 v2-h-56 v2-overflow-hidden ", {
          "v2-shadow": !hideShadow
        }),
        onClick: () => setShowIframe(true),
        onPointerOver: () => setPreConnection(true),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style)
      },
      /* @__PURE__ */ import_react2.default.createElement("link", { rel: "preload", href: posterUrl, as: "image" }),
      /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, preConnection && /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, /* @__PURE__ */ import_react2.default.createElement("link", { rel: "preconnect", href: "https://www.youtube.com" }), /* @__PURE__ */ import_react2.default.createElement("link", { rel: "preconnect", href: "https://www.google.com" }))),
      !showIframe ? /* @__PURE__ */ import_react2.default.createElement("div", { className: "v2-h-full v2-w-full v2-relative v2-cursor-pointer" }, /* @__PURE__ */ import_react2.default.createElement(
        "img",
        {
          className: "v2-h-full v2-w-full v2-object-cover",
          onLoad,
          src: posterUrl
        }
      ), /* @__PURE__ */ import_react2.default.createElement(
        PlayButton,
        {
          className: "v2-h-12 v2-w-[68px] v2-absolute v2-left-2/4 v2-top-2/4",
          src: "https://cdn.bonjoro.com/assets/bonjoro-ui-components/youtube-play.svg"
        }
      )) : /* @__PURE__ */ import_react2.default.createElement(
        "iframe",
        {
          ref: containerRef,
          allowFullScreen: true,
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          src: youtubeEmbedUrl,
          className: "v2-aspect-video v2-w-full v2-h-full v2-border-0",
          onLoad
        }
      )
    );
  }
);
